import { NavValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: NavValues;
  onValuesChange: (field: keyof NavValues, value: number) => void;
  translations: ToolsTranslations['nav'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-4">{translations.inputs.title}</h3>
        
        <div className="space-y-4">
          <div>
            <label htmlFor="totalAssets" className="block text-sm font-medium text-gray-700 mb-2">
              {translations.inputs.totalAssets}
            </label>
            <div className="relative">
              <input
                id="totalAssets"
                type="number"
                value={values.totalAssets}
                onChange={(e) => onValuesChange('totalAssets', parseFloat(e.target.value) || 0)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="0"
                min="0"
                step="0.01"
              />
              <span className="absolute right-3 top-2 text-sm text-gray-500">kr</span>
            </div>
            <p className="text-xs text-gray-500 mt-1">{translations.inputs.totalAssetsHelp}</p>
          </div>

          <div>
            <label htmlFor="totalLiabilities" className="block text-sm font-medium text-gray-700 mb-2">
              {translations.inputs.totalLiabilities}
            </label>
            <div className="relative">
              <input
                id="totalLiabilities"
                type="number"
                value={values.totalLiabilities}
                onChange={(e) => onValuesChange('totalLiabilities', parseFloat(e.target.value) || 0)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="0"
                min="0"
                step="0.01"
              />
              <span className="absolute right-3 top-2 text-sm text-gray-500">kr</span>
            </div>
            <p className="text-xs text-gray-500 mt-1">{translations.inputs.totalLiabilitiesHelp}</p>
          </div>

          <div>
            <label htmlFor="outstandingShares" className="block text-sm font-medium text-gray-700 mb-2">
              {translations.inputs.outstandingShares}
            </label>
            <div className="relative">
              <input
                id="outstandingShares"
                type="number"
                value={values.outstandingShares}
                onChange={(e) => onValuesChange('outstandingShares', parseFloat(e.target.value) || 0)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="0"
                min="0.01"
                step="1"
              />
              <span className="absolute right-3 top-2 text-sm text-gray-500">aktier</span>
            </div>
            <p className="text-xs text-gray-500 mt-1">{translations.inputs.outstandingSharesHelp}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
